import React from "react";
import {Select, Typography} from "antd";
import {useTranslation} from "react-i18next";
import {metadataEntityFieldValue, metadataEntityFieldValues} from "./metadataEntityValues";
import MetadataEntityMultiValueEditor from "./MetadataEntityMultiValueEditor";

export default function MetadataEntityFieldEditor({field, tag, editable, onChange, onStart}) {
    const {t} = useTranslation();
    const displayValue = metadataEntityFieldValue(tag, field);

    if (field.free && field.multi) {
        return <MetadataEntityMultiValueEditor name={field.name} values={metadataEntityFieldValues(tag, field)} editable={editable} onChange={onChange} onStart={onStart}/>;
    }

    if (!editable || field.free) {
        return (
            <Typography.Text editable={editable && {onChange, onStart}}>
                {displayValue}
            </Typography.Text>
        );
    }

    const controlledValues = (field.custom_meta_values_attributes || []).filter(value => !value._destroy);
    const selectedIds = (tag?.metadata_custom_meta_values || [])
        .filter(value => value.custom_meta_field_id === field.id)
        .map(value => value.custom_meta_value_id)
        .filter(value => value !== null && value !== undefined);
    const options = controlledValues.map(value => ({
        value: value.id,
        label: controlledValue(value),
    }));

    const handleChange = selected => {
        const ids = Array.isArray(selected) ? selected : selected === null || selected === undefined ? [] : [selected];
        const values = ids
            .map(id => controlledValues.find(value => value.id === id))
            .filter(Boolean)
            .map(controlledValue);

        onChange(field.multi ? values : values[0] ?? null);
    };

    return (
        <Select
            allowClear
            aria-label={field.name}
            mode={field.multi ? "multiple" : undefined}
            onChange={handleChange}
            optionFilterProp="label"
            options={options}
            placeholder={`${t("select", "Select")}...`}
            showSearch
            style={{minWidth: 180, maxWidth: "100%"}}
            value={field.multi ? selectedIds : selectedIds[0]}
            getPopupContainer={trigger => trigger.parentElement}
        />
    );
}

function controlledValue(value) {
    return [value.text, value.date, value.number, value.value]
        .find(candidate => candidate !== null && candidate !== undefined && candidate !== "");
}
